/**
 * @generated SignedSource<<1b01de6ebd1dcb8a32994a4f96562f0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ItemPickerMilestoneRelayRecentlyUpdatedMilestones$data = {
  readonly id: string;
  readonly milestones: {
    readonly nodes: ReadonlyArray<{
      readonly closed: boolean;
      readonly closedAt: string | null | undefined;
      readonly dueOn: string | null | undefined;
      readonly id: string;
      readonly progressPercentage: number;
      readonly title: string;
      readonly url: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ItemPickerMilestoneRelayRecentlyUpdatedMilestones";
};
export type ItemPickerMilestoneRelayRecentlyUpdatedMilestones$key = {
  readonly " $data"?: ItemPickerMilestoneRelayRecentlyUpdatedMilestones$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemPickerMilestoneRelayRecentlyUpdatedMilestones">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ItemPickerMilestoneRelayRecentlyUpdatedMilestones"
};

(node as any).hash = "49645f2727e82ac0251ce7f6644d2816";

export default node;
